import { ValidateMeasurementDataResponseSchema, type ValidateMeasurementDataResponse } from '@weft/api-definition';
import { ResponseError } from 'libs/client/src/generated';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useValidateMeasurementData(file: File, options?: CustomUseQueryOptions<ValidateMeasurementDataResponse>) {
  return useQuery({
    queryKey: ['validateMeasurementData', file.name],
    queryFn: () => validateMeasurementData(file),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    ...options,
  });
}

async function validateMeasurementData(file: File) {
  const api = getPrivateApi();
  const formData = createFormData(file);

  try {
    const response = await api.validateMeasurementData({ body: formData });

    return ValidateMeasurementDataResponseSchema.parse(response);
  } catch (error) {
    const errorMeassage = await handleValidationError(error);

    throw new Error(errorMeassage);
  }
}

function createFormData(file: File): FormData {
  const formData = new FormData();
  formData.append('file', file);

  return formData;
}

async function handleValidationError(error: unknown) {
  if (error instanceof ResponseError) {
    const errorResponse = await error.response.json();

    return errorResponse.message;
  }
  console.error(error);

  return 'Unknown error';
}